import { render, staticRenderFns } from "./YixiApp.vue?vue&type=template&id=779a9ff1&scoped=true&"
import script from "./YixiApp.vue?vue&type=script&lang=js&"
export * from "./YixiApp.vue?vue&type=script&lang=js&"
import style0 from "./YixiApp.vue?vue&type=style&index=0&id=779a9ff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779a9ff1",
  null
  
)

export default component.exports